import { createI18n, I18n } from "vue-i18n";
import { setLanguage } from "@/utils/storage";
import userService from "@/api/services/userService";
import { useUserStore } from "@/store/user";
import { getTld } from "@/utils/urlHelper.ts";

const de = import("./locales/de.json");
const fr = import("./locales/fr.json");
let allMessages: Record<string, Promise<any>> = { en: Promise.resolve({}) };

if (getTld() !== "net") {
  allMessages = Object.assign(allMessages, { de, fr });
}

const i18n: I18n = createI18n({
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  warnHtmlInMessage: "off",
  locale: "en",
  messages: {},
});

export default i18n;

export const changeLanguage = async (neededLang?: "en" | "de" | "fr") => {
  const lang = neededLang ? neededLang : i18n.global.locale === "de" ? "en" : "de";

  if (!(i18n.global.messages as Record<string, string>)[lang]) {
    const messages: any = await allMessages[lang];
    const messageData = messages.default || messages;
    i18n.global.setLocaleMessage(lang, messageData);
  }

  document.body.classList.remove("lang_en", "lang_de");
  document.body.classList.add(`lang_${lang}`);

  if (i18n.global.locale === lang) {
    return;
  }

  const userStore = useUserStore();

  if (userStore.getProfile) {
    userService.switchLang(lang);
  }

  i18n.global.locale = lang;
  setLanguage(lang);
};
